exports.fastIn = '130ms ease-in'
exports.fastOut = '130ms ease-out'
exports.fastInOut = '130ms ease-in-out'
exports.smoothIn = '230ms ease-in'
exports.smoothOut = '230ms ease-out'
exports.smoothInOut = '230ms ease-in-out'
exports.slowIn = '350ms ease-in'
exports.slowOut = '350ms ease-out'
exports.slowInOut = '350ms ease-in-out'
